export default {
  importData: 'Importar dados',
  importDataTitle: 'Importar Dados',
  copyInstructions: 'Copie este texto para sua planilha, modifique-o e depois copie de volta:',
  modelDataLabel: 'Dados do Modelo',
  cancel: 'Cancelar',
  import: 'Importar',
  set: 'Definir',
  period: 'Período',
  onlyDigitsAllowed: 'Apenas dígitos são permitidos',
  wrongNumberOfRows: 'Número incorreto de linhas',
  wrongNumberOfColumns: 'Número incorreto de colunas',
  invalidHeaderRow: 'Linha de cabeçalho inválida',
  invalidPeriodColumn: 'Coluna de Período inválida',
  onlyWholeNumbersAllowed: 'Apenas números inteiros são permitidos como valores',
  errorShouldBeDate: 'Erro: deve ser uma data'
}
